import {
  FC,
  PropsWithChildren,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';

import QuotationService from '../../../../../../shared/services/quotation';

import {
  ComboWithOptions,
  Group,
  SelectOption,
} from '../../../../../../shared/interfaces';
import { QuotationGroups } from '../../../../NewQuote/containers';
import { RenewalQuotesContext } from './RenewalQuotesContext';

export const RenewalQuotesProvider: FC<PropsWithChildren> = ({ children }) => {
  const [groupsList, setGroupsList] = useState<ComboWithOptions[]>([]);
  const [groupsOptionsList, setGroupsOptionsList] = useState<SelectOption[]>(
    []
  );

  const [articleGroups, setArticleGroups] = useState<Array<Group>>([]);

  const getArticleGroups = useCallback(async () => { 
       
    try {
      const response = await QuotationService.getArticleGroups();
      
      const data = response.data?.Grupos?.map(({ descripcion, articulos }) => ({
        label: descripcion ?? 'Sin label',
        title: descripcion ?? 'Sin título',
        options: articulos.map(({ codigo, descLarga }) => ({
          label: descLarga ?? 'Sin descripción',
          value: codigo ?? 'Sin código',
        })),
      }));

      const dataOptions = response.data.Grupos.map(({ articulos }) =>
        articulos.map(({ descLarga, codigo }) => ({
          label: descLarga ?? 'Sin descripción',
          value: codigo ?? 'Sin código',
        }))
      ).flat();

      setGroupsOptionsList(dataOptions);
      setGroupsList(data);      
      setArticleGroups(response.data.Grupos);
    } catch (error) {
     
      
    }
  }, [
    setGroupsOptionsList,
    setGroupsList,
    setArticleGroups,
  ]);

  const getQuotationGroupByArticle = useCallback((articleId: string): QuotationGroups => {                
    const group = articleGroups.find(el => el.articulos.some(article => Number(article.codigo) === Number(articleId)));    
    return (group?.codigo as QuotationGroups) ?? QuotationGroups.AP;
  }, [articleGroups])

  useEffect(() => {
    getArticleGroups();
  }, []);

  const values = useMemo(
    () => ({
      groupsList,
      groupsOptionsList,
      articleGroups,
      getQuotationGroupByArticle,
      getArticleGroups,
    }),
    [
      groupsList,
      groupsOptionsList,
      articleGroups,
      getQuotationGroupByArticle,
      getArticleGroups
    ]
  );

  return (
    <RenewalQuotesContext.Provider value={values}>
      {children}
    </RenewalQuotesContext.Provider>
  );
};
